import React, {Component} from 'react'
import {Trans, withNamespaces} from 'react-i18next'
import {flowRight as compose, get, find, includes, isEmpty, trim, findKey, some, pickBy, isNil, toLower} from 'lodash'
import AppContext from '../Common/contexts/AppContext'
import withStyles from '@mui/styles/withStyles'
import {Link, withRouter} from 'react-router-dom'
import {corporateFields, corporateStatuses, corporateSteps} from '@bdswiss/common-enums'
import Grid from '@mui/material/Grid'
import {validateCharacters, validateDOB, validateEmail, validatePhone, validateWebsite, validateAddress} from '../../common/utils/validations'
import {scrollElementIntoView} from '../../common/utils'
import messages from '../../assets/messages'
import {graphql} from 'react-apollo'
import {ADD_CORPORATE_DETAILS} from '../../graphql/mutations'
import {CLIENT_DATA_QUERY} from '../../graphql/queries'
import ButtonsToolbar from './ButtonsToobar'
import CorporateStepper from './CorporateStepper'
import Questions, {getStepQuestions} from './Questions'
import NotificationBar from '../Common/NotificationBar'
import moment from 'moment'

const gridScroll = 'scroll-grid'

const styles = theme => ({
  notificationBox: {
    marginTop: 20,
    position: 'relative'
  },
  infoCTA: {
    color: theme.palette.notificationBar.blueTextColor,
  },
})

class GeneralStep extends Component {
  static contextType = AppContext

  constructor(props) {
    super(props)
    const activeStep = corporateSteps.general.rank
    this.state = {
      showDate: {},
      form: {},
      errors : {},
      questions: [],
      loading: false,
      status: '',
      formSubmitted: false,
      initialForm: {},
      formChanged: {},
      closeNotifitication: false,
      prefixChanged: {},
      activeStep,
      nextStep: find(corporateSteps, (step) => step.rank === activeStep + 1)
    }
  }

  componentDidMount() {
    const {viewer} = this.props
    const {activeStep} = this.state
    getStepQuestions(viewer, activeStep, (state) => this.setState(state))
  }

  handleChange (name, value, prefixChange, checkbox) {
    const {initialForm, prefixChanged} = this.state

    if (get(corporateFields[name], 'isCountry') && !prefixChange) {
      if (corporateFields[name].isPrefix) {
        this.setState(state => ({prefixChanged: {...state.prefixChanged, [name]: true}}))
      } else if (!prefixChanged[name]) {
        const country = find(corporateFields[name].options, (country) => country.value === value)
        const nextPrefix = corporateFields[name].prefixChange
        if (nextPrefix && !prefixChanged[nextPrefix]) {
          this.setState(state => ({
            selectedCountry: {...state.selectedCountry, [nextPrefix]: country}}),
          this.handleChange (nextPrefix, `+${get(country,'callingCode', )}`, true))
        }
      }
    }

    this.setState(state => ({
      ...state,
      form: {
        ...state.form,
        [name]: value
      },
      errors: {
        ...state.errors,
        [name]: !checkbox && !value,
      },
      formChanged:{
        ...state.formChanged,
        [name]: isEmpty(initialForm) || (value !== initialForm[name]),
      },
      status: '',
    }))
  }

  scrollUp(errors) {
    this.setState(() => scrollElementIntoView(isEmpty(errors) ? gridScroll : findKey(errors), 250))
  }

  handleSubmit() {
    const {form, activeStep, formSubmitted, nextStep} = this.state
    const submitted = formSubmitted
    const {history} = this.props
    const errors = {}
    const addressFields = ['city', 'correspondenceCity', 'street', 'correspondenceStreet']

    for (const field of Object.keys(form)) {
      const required = corporateFields[field].required(form, undefined, activeStep)
      const relevant = corporateFields[field].relevant(form, undefined, activeStep)
      if (required || (!required && relevant && !isEmpty(form[field]))) {
        if (field === 'email') {
          errors[field] = isEmpty(form[field]) || !validateEmail(form[field])
        } else if (field === 'firstName' || field === 'lastName') {
          const nameError = validateCharacters(trim(form[field]))
          errors[field] = !!nameError
        } else if (field === 'birthday') {
          errors[field] = !validateDOB(form[field])
        } else if (field === 'phone') {
          errors[field] = isEmpty(form[field]) || !validatePhone(form[field])
        } else if (includes(toLower(field), 'website')) {
          errors[field] = isEmpty(form[field]) || !validateWebsite(form[field])
        } else if (includes(addressFields, field)) {
          const addressError = validateAddress(form[field])
          errors[field] = !!addressError
        } else if (includes(toLower(field), 'date')) {
          const today = moment()
          const date = moment(form[field], 'DD/MM/YYYY')
          const dateValid = date.isValid()
          const dateError = isEmpty(form[field]) || !dateValid || (dateValid && today.isBefore(date))
          errors[field] = !!dateError
        } else {
          errors[field] = isEmpty(form[field])
        }
      }
    }

    if (some(errors)) {
      this.setState({errors},this.scrollUp(errors))
      return
    }

    this.setState({loading: true, status: ''})
    this.props.addCorporateDetails({variables: {step: activeStep, answers: JSON.stringify(pickBy(form))}}).then((res) => {
      this.setState({loading: false, status: '', formSubmitted: true},
        history.push({pathname: `/corporate/${nextStep.key}`, state: {step: !submitted ? activeStep + 1 : ''}}))
    }).catch((err) => {
      this.setState({loading: false, status: 'failure'})
    })
  }

  setOuterState (name, key ,value) {
    !isNil(value) ? this.setState(state => ({
      [name]: {
        ...state[name],
        [key]: value
      }
    })) : this.setState({[name]: key})
  }

  render() {
    const {classes, t, viewer, history} = this.props
    const {showDate, selectedCountry, errors, form, questions, disabled, loading, status, formSubmitted, formChanged,
      closeNotifitication, activeStep, nextStep}= this.state
    const {locale} = this.context
    const isFormChanged = !formSubmitted || (formSubmitted && includes(formChanged, true))
    const corporateStatus = get(viewer, 'corporateStatus')

    return <React.Fragment>
      {!corporateStatus && <CorporateStepper activeStep={activeStep - 1} viewerStep={get(viewer, 'corporateSignupStep')}/>}
      {(!formSubmitted || corporateStatus) && !closeNotifitication && <NotificationBar
        status="info"
        classes={{notificationBox: classes.notificationBox}}
        title={<Trans {...messages[(corporateStatus) ? 'corporateCannotChangeDetails' : 'corporateProgressSaved']}
          components={[<Link className={classes.infoCTA} to={'/support'}>support</Link>]}
          values={{corporateStatus: corporateStatus && corporateStatuses[corporateStatus].localization.t(locale)}}
        />}
        onClose={!corporateStatus ? () => this.setState({closeNotifitication: true}) : false}
      />}
      <Grid container spacing={3} id={gridScroll}>
        <Questions
          setOuterState={(name, key ,value) => this.setOuterState(name, key ,value)}
          showDate={showDate}
          selectedCountry={selectedCountry}
          questions={questions}
          form={form}
          errors={errors}
          handleChange={(name, value, _, checkbox) => this.handleChange(name, value, _, checkbox)}
          step={activeStep}
          disabled={corporateStatus}
        />
        {!corporateStatus && <Grid item xs={12}>
          <ButtonsToolbar
            handleSubmit={() => (isFormChanged) ? this.handleSubmit() : history.push(`/corporate/${nextStep.key}`)}
            disabled={disabled || loading}
            status={status}
            label={t(messages[(isFormChanged) ? 'submitAndProceed' : 'next'].i18nKey, messages[(isFormChanged) ? 'submitAndProceed' : 'next'].defaults)}
          />
        </Grid>}
      </Grid>
    </React.Fragment>
  }
}

export default compose(
  withNamespaces(),
  withRouter,
  withStyles(styles, {withTheme: true}),
  graphql(CLIENT_DATA_QUERY, {
    props: ({data: {loading, error}, data}) => ({
      loading,
      error,
      viewer: get(data, 'viewer')
    })
  }),
  graphql(ADD_CORPORATE_DETAILS, {
    name: 'addCorporateDetails',
    options: {
      refetchQueries: [{query: CLIENT_DATA_QUERY}],
    }
  }),
)(GeneralStep)
